<template>
    <div class="file-viewer-wrapper" @click.self="closeFileView">
        <div class="container">
            <div v-if="isImageFile">
                <img :src="file_url" class="centered-media" />
            </div>
            <div v-else>
                <iframe :src="file_url" class="iframe"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        file_url: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isImageFile: false
        };
    },
    async created() {
        this.isImageFile = await this.isImage(this.file_url);
    },
    methods: {
        closeFileView() {
            this.$emit('close');
        },
        async isImage(url) {
            try {
                const response = await fetch(url);
                const blob = await response.blob();
                return blob.type.startsWith('image/');
            } catch (error) {
                console.error('Error fetching the URL', error);
                return false;
            }
        }
    }
}
</script>

<style scoped>
.file-viewer-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height:  100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
}

.container {
    justify-content: center;
    align-items: center;
    background-color: #d4cdc8;
    border-radius: 1cap;

}

.centered-media {
    width: 100%;
    height:  70vh;
    object-fit: contain;
}

.iframe {
    width: 100%;
    height:  70vh;
    object-fit: contain;
}
</style>
